import { useQuery } from "@tanstack/react-query";
import { getNotionConfigs } from "@/services/notion.service";

export default function useNotionConfig() {
  return useQuery({
    queryKey: ["configurations", "notion"],
    queryFn: async () => {
      const result = await getNotionConfigs();
      return result?.data ?? null;
    },
    staleTime: Infinity,
  });
}
